export default "__VITE_ASSET__afcacbfb__"